import React, { useEffect, useState } from 'react';
import { adminApi } from '../../lib/api';
import { useAdminAuth } from './AdminLayout';
import { toast } from 'sonner';
import { Mail, Calendar, User, MessageSquare, Reply } from 'lucide-react';

export default function AdminContact() {
  const { password } = useAdminAuth();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const client = adminApi(password);

  const load = async () => {
    try {
      const res = await client.get('/admin/contact');
      setMessages(res.data);
    } catch (e) {
      toast.error('Failed to load contact messages');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []); // eslint-disable-line

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading font-extrabold text-3xl text-textprimary mb-1">Customer Customer Messages</h1>
        <p className="text-textsecondary font-body text-sm">Review queries and feedback sent via the Contact Us form</p>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-maroon"></div>
        </div>
      ) : (
        <div className="space-y-4">
          {messages.length === 0 ? (
            <div className="bg-white rounded-3xl border border-borderbeige shadow-card p-12 text-center text-textsecondary font-body">
              <Mail className="w-12 h-12 text-textlight mx-auto mb-3" />
              <p>No messages received yet.</p>
            </div>
          ) : (
            messages.map((m) => (
              <div key={m.id} className="bg-white rounded-3xl p-6 shadow-card border border-borderbeige flex flex-col md:flex-row justify-between gap-4 transition-all hover:shadow-warm">
                <div className="space-y-3 flex-1">
                  <div className="flex flex-wrap items-center gap-3">
                    <div className="flex items-center gap-1.5 text-xs text-textsecondary bg-bgmain px-3 py-1 rounded-full border border-borderbeige">
                      <User className="w-3.5 h-3.5 text-maroon" />
                      <span className="font-semibold text-textprimary font-body">{m.name}</span>
                    </div>
                    <div className="flex items-center gap-1.5 text-xs text-textsecondary bg-bgmain px-3 py-1 rounded-full border border-borderbeige">
                      <Mail className="w-3.5 h-3.5 text-maroon" />
                      <a href={`mailto:${m.email}`} className="font-semibold text-maroon hover:underline font-body">{m.email}</a>
                    </div>
                    <div className="flex items-center gap-1.5 text-xs text-textsecondary bg-bgmain px-3 py-1 rounded-full border border-borderbeige">
                      <Calendar className="w-3.5 h-3.5 text-maroon" />
                      <span className="font-body">{new Date(m.created_at).toLocaleString()}</span>
                    </div>
                  </div>

                  <div className="bg-bgmain/50 p-4 rounded-2xl border border-borderbeige/60 mt-1">
                    <div className="flex gap-2">
                      <MessageSquare className="w-4 h-4 text-golden shrink-0 mt-0.5" />
                      <p className="text-sm font-body text-textsecondary whitespace-pre-wrap leading-relaxed">{m.message}</p>
                    </div>
                  </div>
                </div>

                <div className="flex md:flex-col justify-end shrink-0 gap-2">
                  <a
                    href={`mailto:${m.email}?subject=Reply regarding your query to Pushpanjali`}
                    className="inline-flex items-center gap-2 bg-saffron text-white py-2 px-4 rounded-xl font-heading font-medium text-xs shadow-warm hover:bg-saffron-dark transition-colors"
                  >
                    <Reply className="w-3.5 h-3.5" /> Direct Reply
                  </a>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
